export interface CreditPackage {
  id: number;
  name: string;
  credits: number;
  priceAmount: number;
  priceCurrency: string;
  sortOrder: number;
}

export enum PaymentStatus {
  Pending   = 0,
  Completed = 1,
  Failed    = 2,
  Refunded  = 3,
  Cancelled = 4,
}

export enum PaymentPurpose {
  CreditPurchase  = 0,
  CreditTransfer  = 1,
  SeatPurchase    = 2,
}

export interface Payment {
  id: number;
  projectId: number | null;
  organizationId: number | null;
  userId: number | null;
  providerSessionId: string;
  providerPaymentId: string | null;
  credits: number;
  amountPaid: number;
  currency: string;
  transactionId: string | null;
  status: PaymentStatus;
  completedAt: string | null;
  failureReason: string | null;
  createdAt: string;
  createdBy: string;
  updatedAt: string | null;
  updatedBy: string | null;
  paymentPurpose: PaymentPurpose;
  seatCount: number | null;
  rowVersion: number;
}

export interface CheckoutSession {
  sessionId: string;
  url: string;
}

export interface TransferTarget {
  id: number;
  name: string;
  creditBalance: number;
}

export interface TransferCreditsResult {
  sourceBalance: number;
  targetBalance: number;
}
